import { responsiveClassNames } from "../../utilities/props.js";
import s from "./border.module.css";
const getBorderStyles = (value) => {
    if (!value)
        return null;
    return {
        classNames: [s.root, ...responsiveClassNames(s, "--border", value)],
    };
};
export default getBorderStyles;
